import React, { useState } from 'react';

interface TruncatedTextProps {
  text: string;
  maxLength?: number;
  maxLines?: number;
  className?: string;
  showTooltip?: boolean;
  expandable?: boolean;
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  maxLength = 150,
  maxLines = 3,
  className = '',
  showTooltip = true,
  expandable = false
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const shouldTruncateByLength = text.length > maxLength;
  const truncatedText = shouldTruncateByLength ? text.slice(0, maxLength) + '...' : text;

  // CSS classes for line-clamp
  const lineClampClass = maxLines === 1 ? 'line-clamp-1' :
                        maxLines === 2 ? 'line-clamp-2' :
                        maxLines === 3 ? 'line-clamp-3' :
                        maxLines === 4 ? 'line-clamp-4' :
                        maxLines === 5 ? 'line-clamp-5' :
                        maxLines === 6 ? 'line-clamp-6' : 'line-clamp-3';

  const displayText = expandable && isExpanded ? text : (shouldTruncateByLength ? truncatedText : text);

  const containerProps = showTooltip ? { title: text } : {};

  if (expandable && shouldTruncateByLength) {
    return (
      <div className={className}>
        <p className={`${isExpanded ? '' : lineClampClass} overflow-hidden text-ellipsis break-words`}>
          {displayText}
        </p>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-blue-600 hover:text-blue-800 text-sm font-medium mt-1 focus:outline-none"
        >
          {isExpanded ? 'Show Less' : 'Show More'}
        </button>
      </div>
    );
  }

  return (
    <p
      className={`${className} ${lineClampClass} overflow-hidden text-ellipsis break-words`}
      {...containerProps}
    >
      {displayText}
    </p>
  );
};

export default TruncatedText;
